import { render, staticRenderFns } from "./SelectionScreen.vue?vue&type=template&id=46c2d1ce&scoped=true&"
import script from "./SelectionScreen.vue?vue&type=script&lang=ts&"
export * from "./SelectionScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionScreen.vue?vue&type=style&index=0&id=46c2d1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c2d1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c2d1ce')) {
      api.createRecord('46c2d1ce', component.options)
    } else {
      api.reload('46c2d1ce', component.options)
    }
    module.hot.accept("./SelectionScreen.vue?vue&type=template&id=46c2d1ce&scoped=true&", function () {
      api.rerender('46c2d1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SelectionScreen.vue"
export default component.exports